import { spLogTags } from "@eventr/common";
import { useEffect } from "react";
import { CacheFile } from "../../utils";
import { useFileCacher } from "./hooks/useFileCacher";

export const FileCacher = () => {
  const { data } = useFileCacher();
  useEffect(() => {
    spLogTags("FileCacher files to cache: " + (data?.length ?? 0), ["FILES"]);
    spLogTags("FileCacher files to cache data: " + JSON.stringify(data), ["FILES"]);
    const downloadFiles = async () => {
      if (data && data.length > 0) {
        for (let i = 0; i < data.length; i++) {
          const file = data[i];
          if (file === undefined) continue;
          await CacheFile(file);
        }
      }
    };
    downloadFiles();
  }, [data]);

  return null;
};
